<template>
  <div class="pannel">
    <div class="section user-info">
      <div
        class="items"
        @click="
          () => {
            designCategorySelected('template');
          }
        "
      >
        <div class="title">
          <span :class="{ selected: designCategory === 'template' }">{{ $t('editor.design.templates') }}</span>
        </div>
        <div class="templates item" :class="{ selected: designCategory === 'template' }">
          <div class="item-title">{{ resume.template.name }}</div>
          <div class="image" :style="`background-image: url(${resume.template.thumbnailUrl})`" />
        </div>
      </div>
      <div
        class="items"
        @click="
          () => {
            designCategorySelected('colorPalette');
          }
        "
      >
        <div class="title">
          <span :class="{ selected: designCategory === 'colorPalette' }">{{ $t('editor.design.colorPalettes') }}</span>
        </div>
        <div class="color-palette item" :class="{ selected: designCategory === 'colorPalette' }">
          <div class="item-title">{{ colorPaletteName }}</div>
          <div class="colors">
            <div v-for="(color, index) in resume.template.variables" :key="index" class="color">
              <div class="circle" :style="'background-color:' + color.value" />
              <div class="code">{{ color.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LeftPanelDesign',
  components: {},
  props: {
    resume: {
      type: Object,
      required: true,
    },
    designCategory: {
      type: String,
      default: '',
    },
  },

  emits: ['designCategorySelected'],

  computed: {
    ...mapGetters(['templates', 'activeColorPalette']),
    colorPaletteName() {
      return this.currentPalette().name;
    },
  },
  methods: {
    designCategorySelected(category) {
      this.$emit('designCategorySelected', category);
    },
    currentPalette() {
      let palette = null;
      if (this.activeColorPalette[0]) {
        palette = this.resume.template.palettes.find(
          p =>
            p.variables[0].value === this.activeColorPalette[0].value &&
            p.variables[1].value === this.activeColorPalette[1].value &&
            p.variables[2].value === this.activeColorPalette[2].value
        );
      } else {
        palette = this.resume.template.palettes.find(
          p =>
            p.variables[0].value === this.resume.template.variables[0].value &&
            p.variables[1].value === this.resume.template.variables[1].value &&
            p.variables[2].value === this.resume.template.variables[2].value
        );
      }

      if (!palette) {
        palette = this.resume.template.palettes[0];
      }
      return palette;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

$title-height: 32px;
$light-grey-color: grey;

.pannel {
  border-right: solid 1px #d0d0d0;
  width: 200px !important;
}

.section {
  display: flex;
  flex-direction: column;
  &:first-child {
    .title {
      border-top: none;
    }
  }
  .title {
    height: $title-height;
    line-height: $title-height;
    text-transform: uppercase;
    font-weight: bold;
    background-color: white;
    color: colors.$darkest-grey-color;
    border-top: solid 1px #d0d0d0;
    border-bottom: solid 1px #d0d0d0;
    font-size: 14px;
    padding: 2px;
    box-sizing: border-box;
    user-select: none;
    width: 100%;
    cursor: pointer;

    span {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding-left: 10px;
      &.selected {
        background: colors.$secondary-color;
        color: colors.$white-color;
        border-radius: 2px;
      }
    }
  }

  .items {
    height: auto;
    overflow: auto;
    &:focus {
      outline: none;
    }

    .item {
      font-size: 14px;
      color: #7d7d7d;
      padding: 12px;
      box-sizing: border-box;
      user-select: none;
      width: 100%;
      cursor: pointer;
      border-bottom: solid 1px #d0d0d0;
      .item-title {
        width: 100%;
        text-align: left;
        margin-bottom: 5px;
        text-transform: capitalize;
        font-weight: 600;
        font-size: 12px;
      }
      .image {
        height: 211px;
        width: 100%;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
      }
      &:focus {
        outline: none;
      }

      &.selected {
        background: colors.$lighter-yellow-color;
      }
    }
    .color-palette {
      display: flex;
      flex-wrap: wrap;
      .colors {
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        width: 189px;
        .color {
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .circle {
            height: 36px;
            width: 36px;
            border-radius: 50%;
            margin-bottom: 4px;
            border: 1px solid colors.$white-color;
          }
          .code {
            font-size: 9px;
            text-transform: uppercase;
          }
        }
      }
    }
  }
}
</style>
